/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

interface ComponentsConfiguration {
    animationTimeout: number;
}

export const sharedComponentsConfiguration: ComponentsConfiguration = {
    animationTimeout: 3000
};
